const threeDFeaturesEnum = {
    SHOW_HIGHLIGHT: 'show_highlight',
    MOVE_CAMERA_TO_LOCATION: 'move_camera_to_location',
    SHOW_CUE: 'show_cue',
    AWAIT_USER_INPUT: 'await_user_input',
    ALLOW_NEXT_SKIP: 'allow_next_skip',
    ALLOW_BACK: 'allow_back',
    IS_TEST: 'is_test',
    DISABLE_LOWER_CONTROL_PANEL: 'disable_lower_control_panel',
    END_TEST_ON_FAIL: 'end_test_on_fail',
    SHOW_WRONG_PRESS: 'show_wrong_press',
    SHOW_SCORE_TO_USER: 'show_score_to_user',
    END_PROCEDURE_ON_CRITICAL_MISTAKE: 'end_procedure_on_critical_mistake',
    SHOW_SCORE_ON_END_NODE: 'show_score_on_end_node',
    SHOW_HINT_AFTER_X_TRIES: 'show_hint_after_x_tries',
    FAIL_SCORE: 'fail_score',
    DEFAULT_PENALTY_FOR_WRONG_ANSWER: 'default_penalty_for_wrong_answer',
};

module.exports = {
    DEFAULT_SSO_ISSUER: 'frontline.io',
    captchaActionEnum: {
        LOGIN: 'login',
        PASSWORD_ATTEMPT: 'PasswordAttempt',
    },
    environmentEnum: {
        LOCAL: 'local',
        DOCKER: 'docker',
        PKG: 'pkg',
    },
    WorkspacesEnum: {
        GLOBAL: 'global',
        LLS:'lls'
    },
    remoteAssetsTypeEnum: {
        CUSTOM_TOOL: 'CustomToolData'
    },
    threeDFeaturesEnum,
    sessionStatusEnum: {
        NULL: "null",
        COMPLETED: "completed"
    },
    hpUsersEnum: {
        NONE: "none",
        CUSTOMER: "customer",
        EMPLOYEE: "employee",
    },
    responseEnum: {
        OK: 200,
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        ERROR: 500,
        DUPLICATE: 531,
        NOT_EXISTS: 532,
        NO_PERMISSION: 533,
        ILLEGAL_ACTION: 534,
        PAYLOAD_TOO_LARGE: 413,
        TOO_MANY_REQUESTS: 429,
        EXPIRED: 410,
        BLOCKED: 403,
        ALT_AUTH_REQUIRED: 428
        // I_M_A_TEAPOT: 418,
    },
    fileTypeEnum: {
        PNG: 'png',
        MP4: 'mp4',
        IMAGE: 'image',
        VIDEO: 'video',
        PDF: 'pdf',
        RAR: 'rar',
        ZIP: 'zip',
        CSV: 'csv',
        XLS: 'xls',
        XLSX: 'xlsx',
        TXT: 'txt',
        RTF: 'rtf',
        MD: 'md',
        ODT: 'odt',
        GUIDE: 'guide',
        DOCX: 'docx',
        DOC: 'doc',
        HTML: 'html',
        THREE_D: 'three_d',
        FUSION: 'fusion',
        UNITY_PACKAGE: 'unitypackage',
        FRONTLINE_DESIGNER: 'frontline',
        FRONTLINE_WEB: 'frontlineweb',
        FRONTLINE_ANDROID: 'frontlineand',
        FRONTLINE_IOS: 'frontlineios',
        FRONTLINE_HOLOLENS: 'frontlinehololens',
        FRONTLINE_WINDOWS: 'frontlinewin',
        FRONTLINE_MAC: 'frontlinemac',
        FLDT:'fldt',
        OTHER: 'other',
    },
    mediaType:{
        IMAGE: {
            fileName: 'Image',
            mediaType: "image/png",
            fileEnd: '.png'
        },
        VIDEO: {
            fileName: 'Video',
            mediaType: "video/mp4",
            fileEnd: '.mp4'
        },
        MODEL: {
            fileName: 'Model',
            mediaType: "model/glb",
            fileEnd: '.glb'
        }
    },
    policiesEnum: {
        IS_ADMIN : 'is_admin',
        IS_COLLABORATOR_OR_ADMIN : 'is_collaborator_or_admin',
        HAS_ACCESS: 'has_access',
        IS_PROJECT_OWNER: 'is_project_owner',
    },
    permissionsEnum: {
        VIEW_THREE_D_SCENES: 'view_three_d_scenes',
        EDIT_PROCEDURES: 'edit_procedures',
        ANALYTICS_TAB: 'analytics_tab',
        EDIT_COLLABORATORS: 'edit_collaborators',
        VIEW_COLLABORATORS: 'view_collaborators',
        PUBLISH_PROCEDURE: 'publish_procedure',
        MOVE_AND_DELETE_ITEMS: 'move_items', // also delete items
        DUPLICATE_PROCEDURE: 'duplicate_procedure',
        CREATE_PROCEDURE_AND_SETTINGS: 'create_procedure', // also change settings
        VIEW_PROCEDURE_AND_MEDIA: 'view_procedure_media',
        EDIT_CAD_DATA: 'edit_cad_data',
        GET_CAD_DATA: 'get_cad_data',
        SUPPORT_PARTS_CATALOG_LIST: "support_parts_catalog",
        GET_SPARE_PARTS_DATA: 'get_spare_parts_data',
        PROJECT_SETTINGS: 'project_settings',
        PROJECT_DASHBOARD: 'project_dashboard',
        VIEW_UNPUBLISHED: 'view_unpublished',
        VIEW_PUBLISHED: 'view_published',
        DUPLICATE_PROJECT: 'duplicate_project',
        EDIT_ROLES: 'edit_roles',
        ACCESS_MEDIA: 'access_Media',
        UPLOAD_MEDIA: 'upload_Media',
        EDIT_THREE_D_MODES: 'edit_three_d_modes',
        VIEW_REMOTE_SUPPORT: 'view_remote_support',
        VIEW_REMOTE_SUPPORT_DEVICE_ID: 'view_remote_support_device_id',
        CREATE_REMOTE_SUPPORT: 'create_remote_support',
        SCHEDULE_REMOTE_SUPPORT: 'schedule_remote_support',
        CALL_REMOTE_SUPPORT: 'call_remote_support',
        VIEW_REMOTE_SUPPORT_USERS_LIST: 'view_remote_support_users_list',
        VIEW_VIRTUAL_ROOM: 'view_virtual_room',
        CREATE_VIRTUAL_ROOM: 'create_virtual_room',
        SCHEDULE_VIRTUAL_ROOM: 'schedule_virtual_room',
        VIEW_RECORDER: 'view_recorder',
        GENERATE_ANALYTICS_REPORTS: 'generate_analytics_reports',
        SUPPORT_BOOKMARKS_CONTEXT_MENU_OPTIONS: 'support_bookmarks_context_menu_options',
        NEW_OBJECT_TARGET_SYSTEM: 'new_object_target_system',
        IN_APP_DIGITAL_TWIN_CREATION:'in_app_digital_twin_creation',
        VIEW_QR_CODE:'view_qr_code',
        SUPPORT_AI_CHAT: 'support_ai_chat',
        UPLOAD_GUIDE_FILE: 'upload_guide_file',
        AI_STUDIO: 'ai_studio',
        SUPPORT_INTEGRATION: 'support_integration',
        DISABLED_LOCAL_CACHE_SAVING: 'disable_local_cache_saving',
        RECORD_CALLS: 'record_calls',
        AI_TRANSLATION: 'ai_translation',
        AI_GENERATION: 'ai',
        SHARE_ITEM: 'share_item',
        UPDATE_DOMAIN_MATERIALS: 'update_domain_materials',
        EDIT_PUBLIC_BOOKMARK: 'edit_public_bookmark',
        SITE_PREP: 'site_prep',
        //TODO when adding new permissions, remove from legacyPermissionsSet in userLogic.js => getPermissionSet()
    },
    frontlinePermissionEnum:{
        FRONTLINE_CONTENT_CREATOR: 'frontline_content_creator',
    },
    guestPermissionsEnum: {
        VIEW_THREE_D_SCENES: 'view_three_d_scenes',
        VIEW_PROCEDURE_AND_MEDIA: 'view_procedure_media',
        VIEW_COLLABORATORS: 'view_collaborators',
        VIEW_REMOTE_SUPPORT: 'view_remote_support',
        VIEW_REMOTE_SUPPORT_DEVICE_ID: 'view_remote_support_device_id',
        VIEW_REMOTE_SUPPORT_USERS_LIST: 'view_remote_support_users_list',
        VIEW_VIRTUAL_ROOM: 'view_virtual_room',
        VIEW_PUBLISHED: 'view_published',
        VIEW_RECORDER: 'view_recorder',
        SUPPORT_PARTS_CATALOG_LIST: "support_parts_catalog",
        NEW_OBJECT_TARGET_SYSTEM: 'new_object_target_system'
    },
    legacyPermissionsEnum: {
        VIEW_THREE_D_SCENES: 'view_three_d_scenes',
        EDIT_PROCEDURES: 'edit_procedures',
        ANALYTICS_TAB: 'analytics_tab',
        EDIT_COLLABORATORS: 'edit_collaborators',
        VIEW_COLLABORATORS: 'view_collaborators',
        PUBLISH_PROCEDURE: 'publish_procedure',
        MOVE_AND_DELETE_ITEMS: 'move_items', // also delete items
        DUPLICATE_PROCEDURE: 'duplicate_procedure',
        CREATE_PROCEDURE_AND_SETTINGS: 'create_procedure', // also change settings
        PROJECT_SETTINGS: 'project_settings',
        PROJECT_DASHBOARD: 'project_dashboard',
        VIEW_UNPUBLISHED: 'view_unpublished',
        VIEW_PUBLISHED: 'view_published',
        DUPLICATE_PROJECT: 'duplicate_project',
        EDIT_ROLES: 'edit_roles',
        ACCESS_MEDIA: 'access_Media',
        EDIT_THREE_D_MODES: 'edit_three_d_modes',
        VIEW_REMOTE_SUPPORT: 'view_remote_support',
        VIEW_REMOTE_SUPPORT_DEVICE_ID: 'view_remote_support_device_id',
        CREATE_REMOTE_SUPPORT: 'create_remote_support',
        SCHEDULE_REMOTE_SUPPORT: 'schedule_remote_support',
        CALL_REMOTE_SUPPORT: 'call_remote_support',
        VIEW_REMOTE_SUPPORT_USERS_LIST: 'view_remote_support_users_list',
        VIEW_VIRTUAL_ROOM: 'view_virtual_room',
        CREATE_VIRTUAL_ROOM: 'create_virtual_room',
        SCHEDULE_VIRTUAL_ROOM: 'schedule_virtual_room',
        VIEW_RECORDER: 'view_recorder',
    },
    sceneObjectTypeEnum: {
        IMAGE: 0,
        VIDEO: 1,
        PDF: 2,
        THREE_D: 3,
        WEB: 4,
        AUDIO: 5,
        TEXT_NOTE: 6,
        DRAW_NODE: 7,
        MEASURE: 8,
        INTERNAL_MODEL: 9,
    },
    doceboStatusEnum: {
        FAILED: 'failed',
        STARTED: 'started',
        COMPLETED: 'completed',
    },
    procedureTypeEnum: {
        REGULAR: 0,
        MEDIA: 1,
        THREE_D: 2,
        FUSION: 3,
        VIRTUAL_ROOM: 4,
        SITE_PREP: 5,
        PATIENT: 6,
        LINK: 7,
        DESIGNER: 8,
        VIRTUAL_CLASS_ROOM: 9,
    },
    procedureNodeTypeEnum: {
        START: 0,
        SINGLE: 1,
        QUESTION: 2,
        MULTI: 3,
        WARNING: 4,
        Input: 5,
        END: 6,
        INNER_PROCEDURE: 7,
        WARNING_POPUP: 8,
        CONNECTION_POINT: 9,
        PLATFORM_SWITCH: 10, // To be used in the future
        OBJECT_DETECTION: 11
    },
    fontsEnum: {
        BRIGHT: 0,
        DARK: 1,
        DISABLED: 2,
        LINK: 3,
        LEAVE_DELETE_NEW: 4
    },
    editorNodeTypeEnum: {
        START: 'start',
        QUESTION: 'question',
        MULTI: 'multiChoice',
        WARNING: 'warningNode',
        WARNING_POPUP: 'warningPopUp',
        INPUT: 'inputNode',
        INNER_PROCEDURE: 'gotoProcedure',
        STEP: 'step',
        CONNECTION_POINT: 'connectionPoint',
        PLATFORM_SWITCH: 'platformSwitch', // To be used in the future
        OBJECT_DETECTION: 'objectDetection'
    },
    AnimationManagerEnum: {
      ROOT:'root',
      ANIMATION_MANAGER:'Animation Manager',
      STUDIO_ANIMATION:'3D studio animation',
    },
    uploadStatusEnum: {
        REGULAR: 'frontline',
        AWAITING_UPLOAD: 'awaiting_upload',
        CAD_FILE_PENDING: 'cad_file_pending',
        CAD_FILE: 'cad_file',
    },
    sitePrepActiveStateEnum: {
        NOT_APPROVED: 0,
        PENDING: 1,
        APPROVED: 2,
    },
    userTypeEnum: {
        DOMAIN_OWNER: 1,
        DOMAIN_ADMIN: 2,
        PROJECT_OWNER: 3,
        SYSTEM_USER: 4,
        MOBILE_USER: 5
    },
    sitePrepUserTypeEnum: {
        EDITOR: "editor",
        VIEWER: "viewer",
    },
    userStatusEnum: {
        ACTIVE: 1,
        DELETED: 3,
    },
    inputTypeEnum: {
        NUMBER: 1,
        TEXT: 2,
        IMAGE: 3,
        BARCODE: 4
    },
    runProcedureInEnum: {
        TWO_D: "two_d",
        THREE_D: "three_d",
        BOTH: "both"
    },
    procedureNodeStyleEnum: {
        TOP: 'TOP',
        TOP_OLD: 'top',
        BOTTOM: 'BOTTOM',
        BOTTOM_OLD: 'bottom',
        LEFT: 'LEFT',
        LEFT_OLD: 'left',
        RIGHT: 'RIGHT',
        RIGHT_OLD: 'right',
        FLOAT: 'FLOAT',
        FLOAT_OLD: 'float'
    },
    animationManagerFoldersEnum: {
        ANIMATION_MANAGER: 'animationManager',
        STUDIO_ANIMATION: 'studioAnimation',
    },
    deviceTypeEnum: {
        OLD_PC: 'PC',
        OLD_STANDALONE: 'standalone',
        WEB: 'Web Browser',
        ANDROID: 'Android',
        IOS: 'iOS',
        STANDALONE: 'Standalone',
        WINDOWS: 'Windows',
        MAC_OS: 'MacOS',
        HOLO_LENS: 'HoloLens',
        SDK: 'SDK',
        ML2: 'ML2',
    },
    browserEnum: {
        MOZILLA: 'Mozilla',
        CHROME: 'Chrome',
        Safari: 'Safari',
        Firefox: 'Firefox',
        Opera: 'Opera',
        Edge: 'Edge',
    },
    trainingAndFieldRoleEnum: {
        OPERATOR: 'operator',
        OPERATOR_3D: 'operator MR',
        FIELD_SERVICE_ENGINEER: 'fieldServiceEngineer',
        SERVICE_SUPPORT_EXPERT: 'serviceSupportExpert',
        INSTRUCTOR: 'instructor',
        SERVICE_SUPPORT_MANAGER: 'serviceSupportManager',
        NONE: 'none',
    },
    contentCreatingRoleEnum: {
        CONTENT_CREATOR: 'contentCreator',
        ADVANCED_CONTENT_CREATOR: 'advancedContentCreator',
        NONE: 'none',
    },
    trainingAndFieldRolePermissionEnum: {
        OPERATOR: 'operates equipment using flows',
            OPERATOR_3D: 'Uses mixed reality for equipment tasks',
            FIELD_SERVICE_ENGINEER: 'fieldServiceEngineer',
            SERVICE_SUPPORT_EXPERT: 'Remote troubleshooting and support',
            INSTRUCTOR: 'Train staff on equipment',
            SERVICE_SUPPORT_MANAGER: 'Manage support teams operations',
            NONE: 'No training permissions',
    },
    contentCreatingRolePermissionEnum: {
        CONTENT_CREATOR: 'Builds interactive training content',
            ADVANCED_CONTENT_CREATOR: 'Enhanced tools for content creation',
            NONE: 'No content creation permissions',
    },
    reverseTrainingAndFieldRoleEnum: {
        'operator': 'OPERATOR',
        'operator MR': 'OPERATOR_3D',
        'fieldServiceEngineer': 'FIELD_SERVICE_ENGINEER',
        'serviceSupportExpert': 'SERVICE_SUPPORT_EXPERT',
        'instructor': 'INSTRUCTOR',
        'serviceSupportManager': 'SERVICE_SUPPORT_MANAGER',
        'none': 'NONE'
    },
    reverseContentCreatingRoleEnum: {
        'contentCreator': 'CONTENT_CREATOR',
        'advancedContentCreator': 'ADVANCED_CONTENT_CREATOR',
        'none': 'NONE'
    },
    administrationRoleEnum: {
        USAGE_ANALYSIS: 'usageAnalysis',
        WORKSPACE_ADMIN: 'workspaceAdmin',
        NONE: 'none',
    },
    workspaceUsersEnum: {
        USAGE_ANALYSIS: 'usageAnalysis',
        WORKSPACE_ADMIN: 'workspaceAdmin',
        WORKSPACE_OWNER: 'workspaceOwner',
        NONE: 'none',
    },
    notificationActionEnum: {
        GO_TO_CONNECTED: "go_to_connected",
        GO_TO_USERS: "go_to_domain_users",
        ACCEPT_DECLINE: "accept_decline",
        GO_TO_CALL: "go_to_call",
    },

    notificationCategoryEnum: {
        PROCEDURE: "knowledge_base",
        DOMAIN: "workspace_management",
    },
    editorCkeEnum: {
        HEADER: 'StepHeader',
        DESCRIPTION: 'StepText',
        CONFIRMATION: 'ConformationText',
    },
    notificationTypeEnum: {     //first word of prop must equal category (eg. TASK, PROCEDURE, DOMAIN, etc.)
        TASK_ASSIGNED: "task_assigned",
        TASK_STATUS_CHANGED: "task_status_changed",
        TASK_DUE_SOON: "task_due_soon",
        // TASK_COMMENT_ADDED: "task_comment_added",
        // TASK_ARCHIVED: "task_archived",
        // PROCEDURE_ADDED_TO_PROJECT: "added_to_project",
        PROCEDURE_PUBLISHED: "procedure_published",
        PROCEDURE_SITE_PREP_PUBLISH_PENDING: 'site_prep_publish_approval_pending',
        DOMAIN_NEW_USER: "domain_new_user",
        DOMAIN_MAX_USERS_SOON: "domain_max_users_soon",
        NEW_COLLABORATOR: 'new_collaborator',
        PENDING_USER_APPROVAL: 'pending_user_approval',
        USER_DECLINED: 'user_declined',
        USER_APPROVED: 'user_approved',
        DOMAIN_PENDING_PAY_PER_CLICK: 'pending_pay_per_click',
        DOMAIN_PAY_PER_CLICK_LIMIT_SOON: 'pay_per_click_limit_soon',
    },
    pncProgressEnum: {
        DONE: "done",
        PENDING: "pending",
        IN_PROGRESS: "in_progress"
    },

    threeDFeaturesDetails: {
        [threeDFeaturesEnum.SHOW_HIGHLIGHT]: {
            title: 'showHighlight',
            tooltip: '',
            type: Boolean,
            default: true
        },
        [threeDFeaturesEnum.MOVE_CAMERA_TO_LOCATION]: {
            title: 'moveCameraToLocation',
            tooltip: '',
            type: Boolean,
            default: true
        },
        [threeDFeaturesEnum.SHOW_CUE]: {
            title: 'showCue',
            tooltip: '',
            type: Boolean,
            default: true
        },
        [threeDFeaturesEnum.AWAIT_USER_INPUT]: {
            title: 'awaitUserInput',
            tooltip: '',
            type: Boolean,
            default: true
        },
        [threeDFeaturesEnum.ALLOW_NEXT_SKIP]: {
            title: 'allowNextSkip',
            tooltip: '',
            type: Boolean,
            default: true
        },
        [threeDFeaturesEnum.ALLOW_BACK]: {
            title: 'allowBack',
            tooltip: '',
            type: Boolean,
            default: true
        },
        [threeDFeaturesEnum.IS_TEST]: {
            title: 'isTest',
            tooltip: '',
            type: Boolean,
        },
        [threeDFeaturesEnum.DISABLE_LOWER_CONTROL_PANEL]: {
            title: 'disableLowerControlPanel',
            tooltip: '',
            type: Boolean
        },
        [threeDFeaturesEnum.END_TEST_ON_FAIL]: {
            title: 'endTestOnFail',
            tooltip: '',
            type: Boolean
        },
        [threeDFeaturesEnum.SHOW_WRONG_PRESS]: {
            title: 'showWrongPress',
            tooltip: '',
            type: Boolean,
            disabledBy: threeDFeaturesEnum.IS_TEST
        },
        [threeDFeaturesEnum.SHOW_HINT_AFTER_X_TRIES]: {
            title: 'showHintAfterXTries',
            tooltip: 'zeroIsNever',
            type: Number,
            default: 0,
            disabledBy: threeDFeaturesEnum.IS_TEST
        },
        [threeDFeaturesEnum.FAIL_SCORE]: {
            title: 'failScore',
            tooltip: '',
            type: Number,
            default: 55,
            disabledBy: threeDFeaturesEnum.IS_TEST
        },
        [threeDFeaturesEnum.DEFAULT_PENALTY_FOR_WRONG_ANSWER]: {
            title: 'defaultPenaltyForWrongAnswer',
            tooltip: '',
            type: Number,
            default: 5,
            disabledBy: threeDFeaturesEnum.IS_TEST
        },
        [threeDFeaturesEnum.SHOW_SCORE_TO_USER]: {
            title: 'showScoreToUser',
            tooltip: '',
            type: Boolean,
            disabledBy: threeDFeaturesEnum.IS_TEST
        },
        [threeDFeaturesEnum.END_PROCEDURE_ON_CRITICAL_MISTAKE]: {
            title: 'endFlowOnCriticalMistake',
            tooltip: '',
            type: Boolean,
            disabledBy: threeDFeaturesEnum.IS_TEST
        },
        [threeDFeaturesEnum.SHOW_SCORE_ON_END_NODE]: {
            title: 'showScoreOnEndNode',
            tooltip: '',
            type: Boolean,
            disabledBy: threeDFeaturesEnum.IS_TEST
        }
    },
    dayadaQuestionTypeEnum: {
        TEXT: "TEXT",
        MULTI_CHOICE: "MULTI_CHOICE",
        SINGLE_CHOICE: "SINGLE_CHOICE",
        SCALE: "SCALE",
    },
    dayadaLiveWithEnum: {
        ALONE: "ALONE",
        FAMILY: "FAMILY",
        LIVING_CAREGIVER: "LIVING_CAREGIVER",
        HOURS_CAREGIVER: "HOURS_CAREGIVER",
    },
    dayadaHouseOwnershipEnum: {
        OWNER: "OWNER",
        RENT: "RENT",
        PUBLIC: "PUBLIC"
    },
    dayadaHouseTypeEnum: {
        SHARED: "SHARED",
        PRIVATE: "PRIVATE"
    },
    payPerClickTypeEnum: {
        LIMITED: "LIMITED",
        RECURRING: "RECURRING"
    },
    payPerClickStatusEnum: {
        ACTIVE: 0,
        PAUSED: 1,
        DONE: 2,
        CANCELED: 3
    },
    domainEventTypeEnum: {
        GRANT_USER_SDK: "GRANT_USER_SDK",
        REMOVE_USER_SDK: "REMOVE_USER_SDK",
        USER_DOWNLOADED_SDK: "USER_DOWNLOADED_SDK",
        PAY_PER_CLICK_LINK_USED: "PAY_PER_CLICK_LINK_USED",
        CHANGE_ROLE: "CHANGE_ROLE",
        JOIN_WORKSPACE: "JOIN_WORKSPACE",
        CREATE_WORKSPACE: "CREATE_WORKSPACE",
    },
    languageEnum: {
        ENGLISH_US: "EN-US",
        ENGLISH_GB: "EN-GB",
        FRENCH: "FR",
        ITALIAN: "IT",
        GERMAN: "DE",
        SPANISH_ES: "ES-ES",
        SPANISH_MX: "ES-MX",
        PORTUGUESE_PT: "PT-PT",
        PORTUGUESE_BR: "PT-BR",
        JAPANESE: "JP",
        KOREAN: "KR",
        CHINESE_CN: "CN-CN",
        CHINESE_HK: "CN-HK",
        RUSSIAN: "RU"
    },
    preferredLanguageEnum: {
        ENGLISH_US: "en-US",
        ENGLISH_GB: "en-US",
        FRENCH: "fr-FR",
        ITALIAN: "it-IT",
        GERMAN: "de-DE",
        SPANISH_ES: "es-ES",
        SPANISH_MX: "ES-MX",
        PORTUGUESE_PT: "pt-PT",
        PORTUGUESE_BR: "pt-PT",
        JAPANESE: "ja-JP",
        KOREAN: "ko-KR",
        CHINESE_CN: "zh-CN",
        CHINESE_HK: "zh-CN",
        RUSSIAN: "ru-RU"
    },
    translationLanguageEnum: {
        ENGLISH: "en-US",
        ENGLISH_GB: "en-GB",
        FRENCH: "fr-FR",
        ITALIAN: "it-IT",
        GERMAN: "de-DE",
        SPANISH: "es-ES",
        SPANISH_MX: "es-MX",
        PORTUGUESE: "pt-PT",
        PORTUGUESE_BR: "pt-BR",
        JAPANESE: "ja-JP",
        KOREAN: "ko-KR",
        CHINESE: "zh-CN",
        CHINESE_HK: "zh-HK",
        RUSSIAN: "ru-RU",
        INDONESIAN: "id-ID",
        POLISH: "pl-PL",
        DUTCH_NL: "nl-NL"
    },
    ttsLanguagesEnum: {
        'en-US': 'en-US-JennyMultilingualNeural',
        'de-DE': 'en-US-JennyMultilingualNeural',
        'en-AU': 'en-US-JennyMultilingualNeural',
        'en-CA': 'en-US-JennyMultilingualNeural',
        'en-GB': 'en-US-JennyMultilingualNeural',
        'es-ES': 'en-US-JennyMultilingualNeural',
        'es-MX': 'en-US-JennyMultilingualNeural',
        'fr-CA': 'en-US-JennyMultilingualNeural',
        'fr-FR': 'en-US-JennyMultilingualNeural',
        'it-IT': 'en-US-JennyMultilingualNeural',
        'ja-JP': 'en-US-JennyMultilingualNeural',
        'ko-KR': 'en-US-JennyMultilingualNeural',
        'pt-BR': 'en-US-JennyMultilingualNeural',
        'zh-CN': 'en-US-JennyMultilingualNeural',
        'ru-RU': 'ru-RU-DariyaNeural',
        'zh-HK': 'zh-HK-HiuGaaiNeural',
        'pt-PT': 'pt-PT-FernandaNeural'
    },
    filtersEnum: {
        ALL: 'all',
        OWNED: 'owned',
        SHARED: 'shared'
    },
    sortEnum: {
        NAME: "name",
        CREATION_DATE: "creationDateNewFirst",
        LAST_MODIFIED: "lastModified"
    },
    versionTypeEnum: {
        PUBLISH: 'publish',
        ROLLBACK: 'rollback',
        UN_PUBLISH: 'un_publish',
    },
    releaseNoteVersionEnum: {
        HP:'HP',
        APP:'APP',
    },
    guidesProcedureEnum: {
        COVER_PHOTO_ID: '_msmrw_anchorstepimage_value',
        COVER_PHOTO_NAME: '_msmrw_anchorstepimage_value@OData.Community.Display.V1.FormattedValue',
        NESTED_NODES: 'msmrw_GuideStep_Guide_msmrw_guide',
        STEP_IMAGE_ID: '_msmrw_image_value',
        STEP_IMAGE_NAME: '_msmrw_image_value@OData.Community.Display.V1.FormattedValue',
        STEP_VIDEO_ID: '_msmrw_video_value',
        STEP_VIDEO_NAME: '_msmrw_video_value@OData.Community.Display.V1.FormattedValue',
        STEP_TEXT: 'msmrw_instructiontext',
        TASK_NAME: '_msmrw_task_value@OData.Community.Display.V1.FormattedValue',
        PREVIOUS_STEP: '_msmrw_previousstep_value',
        DESCRIPTION: 'msmrw_anchorstepinstructiontext',
        TASKS: 'msmrw_GuideTask_Guide_msmrw_guide',
        TASK_ID: '_msmrw_task_value',
        PREV_TASK_ID: '_msmrw_previoustask_value',
        TASK_NAME_IN_LIST: 'msmrw_name',
        TASK_ID_IN_LIST: 'msmrw_guidetaskid',
        PROCEDURE: 'Guide_Body',
        IMAGE: 'Image_Body',
        VIDEO: 'Video_Body',
        MODEL: 'Model_Body',
        TOOLS: 'msmrw_msmrw_guide_msmrw_guidestepobject_Guide',
        TOOL_NAME: '_msmrw_3dobject_value@OData.Community.Display.V1.FormattedValue',
        TOOL_ID: 'msmrw_guidestepobjectid',
        TOOLS_ID: '_msmrw_3dobject_value',
        TOOL_INDEX: 'msmrw_index',
        TOOLS_NODE_ID: '_msmrw_guidestep_value',
        TOOLS_DATA: 'msmrw_msmrw_guide_msmrw_guidestepobjectplacement_Guide',
        TOOLS_DATA_ID: '_msmrw_guidestepobject_value',
        TOOL_GUIDE_PLACEMENT_ID: 'msmrw_guidestepobjectplacementid',
        TOOL_ANIMATION_NAME: 'msmrw_3dobjectanimationtake',
        TOOL_ANIMATION_DIRECTION: 'msmrw_3dobjectanimationdirection@OData.Community.Display.V1.FormattedValue',
        TOOL_ANIMATION_MODE: 'msmrw_3dobjectanimationmode@OData.Community.Display.V1.FormattedValue',
        TOOL_IS_OBJECT_ANIMATED: 'msmrw_3dobjectisanimated',
        TOOL_X_POSITION: 'msmrw_positionx',
        TOOL_Y_POSITION: 'msmrw_positiony',
        TOOL_Z_POSITION: 'msmrw_positionz',
        TOOL_X_ROTATION: 'msmrw_rotationx',
        TOOL_Y_ROTATION: 'msmrw_rotationy',
        TOOL_Z_ROTATION: 'msmrw_rotationz',
        TOOL_W_ROTATION: 'msmrw_rotationw',
        TOOL_X_SCALE: 'msmrw_scalex',
        TOOL_Y_SCALE: 'msmrw_scaley',
        TOOL_Z_SCALE: 'msmrw_scalez',
        BUTTONS: 'msmrw_msmrw_guide_msmrw_guidestepobject_Guide',
        BUTTON_VALUE_ENTER: "msmrw_guidestepobjecttriggeractivation@OData.Community.Display.V1.FormattedValue",
        ENTER: "On Hand Enter",
        BUTTON_VALUE_GO_TO: "msmrw_guidestepobjecttriggeraction@OData.Community.Display.V1.FormattedValue",
        GO_TO: "Go To Step",
        BUTTON_VALUE_INVISIBLE: "_msmrw_3dobject_value@OData.Community.Display.V1.FormattedValue",
        INVISIBLE: "Invisible",
        BUTTON_DESTINATION: "_msmrw_guidestepobjecttriggerdestination_value",
        BUTTON_VALUE: "_msmrw_guidestep_value",
    },
    guideStatusEnum: {
        PROCESSING: 'PROCESSING',
        FAILED: 'FAILED',
        SUCCESS: 'SUCCESS',
    },

    sortingArrangeEnum: {
        ASCENDING: 'asc',
        DESCENDING: 'desc',
    },
    tableDataType: {
        DATE: 'date',
        TEXT_OR_NUMBER: 'text or number',
        STATUS: 'status',
        LINK: 'link',
        BOOLEAN: 'boolean',
        MULTI_CHOICE: 'multi_choice',
    },
    tableActionType: {
        FETCH: 'fetch',
        DELETE:'delete',
        CREATE_OR_UPDATE:'create_or_update',
    },
    DomainStatusEnum : {
        ACTIVE: 'active',
        PENDING_APPROVAL: 'pending approval',
        BLOCKED: 'blocked',
        EXPIRED: 'expired',
        DELETED: 'deleted'
    },
    DomainRoutes: {
      LIST: 'list',
        SETTINGS: 'settings',
    },
    LoadMoreStateEnum: {
        LOADING: 'Loading more...',
        NO_MORE: 'No more data',
    },
    WorkspaceFlags: {
        Remote_Support_web: 'IsRemoteSupportWebOff',
        Remote_Support_Terms_Of_Use: 'IsRemoteSupportTermsOfUseEnabled',
        REMOTE_SUPPORT_SETTINGS: 'IsRemoteSupportAfterCallSurveyEnabled'
    },
    AiContextViewEnum: {
        WORKSPACE: 'Workspace',
        PROJECT: 'Project',
        PROCEDURE: 'Procedure',
        Digital_Twin: 'Digital Twin',
        CONTENT_CREATION: 'Content Creation'

    },
    AiContextDataEnum:{
        WORKSPACE: 'workspace',
        PROJECT: 'project',
        PROCEDURE_OR_DIGITAL_TWIN: 'procedureOrDigitalTwin',
        PROCEDURE_EDITOR: 'procedureEditor',
    },
    AllowedFileExtensionsAiChatUploads: {
        PDF: "pdf",
        DOCX: "docx",
        TXT: "txt",
        RTF: "rtf",
        ODT: "odt",
        XLS: "xls",
        XLSX: "xlsx",
        CSV: "csv",
        MD: "md",
        HTML: "html",
        PNG: "png",
        JPG: "jpg",
        JPEG: "jpeg",
        IMAGE: "image",
        GIF: "gif",
        MP4: "mp4",
        VIDEO: "video",
    },
    AllowedMimeTypesAiChatUploads: {
        MARKDOWN: "text/markdown",
        PLAIN: "text/plain",
        CSV: "text/csv",
        HTML: "text/html",
        JPEG: "image/jpeg",
        PNG: "image/png",
        GIF: "image/gif",
        PDF: "application/pdf",
        OCTET_STREAM: "application/octet-stream"
    },
    AiChatToolsNameEnum: {
        CONVERT_TEXT_TO_PROCEDURE: 'convert text to procedure',
        EDIT_PROCEDURE_FLOW: 'manage procedure steps(add, edit, delete nodes)',
        TRANSLATE_NODES: 'translate nodes',
        EDIT_PROCEDURE_SETTINGS: 'edit procedure properties and settings',
        EDIT_DIGITAL_TWIN_SETTINGS: 'edit digital twin settings',
        EDIT_PROJECT_ITEMS: "rearrange edit rename project items, create new folders, add files",
        CREATE_NEW_PROCEDURE: 'create procedures based on files and instructions'
    },
    FileTypesToUploadAiStudio: {
        IMAGE_MIME: '^image/',
        JPG: '\\.jpg$',
        JPEG: '\\.jpeg$',
        PNG: '\\.png$',
        GIF: '\\.gif$',
        BMP: '\\.bmp$',
        VIDEO_MIME: '^video/',
        MP4: '\\.mp4$'
    },
    SupportedCrmEnum: {
        SALESFORCE: 'salesforce',
    },
    SurveyTypeEnum: {
        REMOTE_SUPPORT_POST_CALL: 'remote_support_post_call'
    },
    SurveyQuestionTypeEnum: {
        RATING_SCALE: 'rating_scale',
        MULTIPLE_CHOICE: 'multiple_choice',
        TEXT_RESPONSE: 'text_response',
        YES_NO: 'yes_no'
    },
    RecordingStatusEnum: {
        INITIALIZING: 'initializing',
        IN_PROGRESS: 'in_progress',
        STOPPING: 'stopping',
        FINALIZING: 'finalizing',
        COMPLETED: 'completed',
        FAILED: 'failed',
    },
    RecordingRank: {
        COMPLETED_ONLY: 3,
        MIXED: 2,
        FAILED_WITH_TIME: 1,
        NONE: 0
    },
    accessIncludeLevelEnum: {
        SELF: 0,
        DIRECT_CHILDREN: 1,
        ALL_DESCENDANTS: 2,
    },
    accessGroupEnum: {
        WORKSPACE_PUBLIC: 'public',
        GUEST: 'guest',
    },
    grantedViaEnum: {
        DIRECT: 'direct',
        GUEST: 'guest',
    },
    accessSourceTypeEnum: {
        GROUP: 'group',
        SPECIAL: 'special',
        DIRECT: 'direct',
    },
    shareItemTypeEnum: {
        GROUP: 'group',
        MEMBER: 'member',
    },
    accessSourceNameEnum: {
        PUBLIC: 'Public',
        GUEST: 'Guest',
    },
    accessItemTypeEnum: {
        PROJECT: 'project',
        FOLDER: 'folder',
        ITEM: 'item',
    },
    ROOT_FOLDER_ID: 'root',
    projectPrivacyLevelEnum: {
        PRIVATE: 'private',
        WORKSPACE_PUBLIC: 'workspacePublic',
        PUBLIC: 'public',
    },
    checkboxStateEnum: {
        EMPTY: 'empty',
        CHECKED: 'checked',
        INDETERMINATE: 'indeterminate',
        INCLUDE_ALL: 'includeAll',
    },
    selectDataTypeEnum: {
        MEMBERS: 'members',
        GROUPS: 'groups',
        BOTH: 'both',
    },
    memberFieldEnum: {
        TRAINING_AND_FIELD_ROLE: 'TrainingAndFieldRole',
        CONTENT_CREATION_ROLE: 'ContentCreationRole',
        ADMINISTRATION_ROLE: 'AdministrationRole',
        IS_WORKSPACE_OWNER: 'IsWorkspaceOwner',
        GROUPS: 'Groups',
        EMAIL: 'Email',
        FULL_NAME_LOWER: 'FullNameLower',
        LAST_ACTIVE_DATE: 'LastActiveDate',
        INVITED_ON: 'InvitedOn',
    },
    aiUsagesType: {
        AI_CHAT: 'aiChat',
        AI_INSTRUCTIONS: 'aiInstructions',
        AI_TRANSLATION: 'aiTranslation',
        OTHER: 'other',

    }
};
